import styled from "styled-components";
import AntBreadCrumbs from "uiKits/BreadCrums";
import { CONTENT_WIDTH, media } from "@/theme/breakpoints";

export const StyledBreadCrumbs = styled(AntBreadCrumbs)``;

export const PageRoot = styled.div`
  overflow-x: hidden;
  width: 100%;
`;

export const HeroSection = styled.div`
  width: ${CONTENT_WIDTH.pct};
  max-width: 100%;
  margin: 0 auto;
  margin-bottom: 90px;
  box-sizing: border-box;

  ${media.downTablet`
    margin-bottom: 30px;
    padding: 0 24px;
  `}

  ${media.downMobile`
    padding: 0 16px;
    margin-bottom: 24px;
  `}
`;

export const StyledImage = styled.img`
  width: 100%;
  max-width: 100%;
  height: auto;
`;
